<template>
  <div class="relative">
    <div class="flex justify-between">
      <p>Variables</p>
      <p
        class="underline cursor-pointer font-bold"
        @click="showAll = !showAll"
      >
        {{ showAll ? "Show only changes" : "Show all" }}
      </p>
    </div>
    <expandabel-table
    :columnsToNotSort="columnsToNotSort" 
    :data="currentVariables" 
    :headers="headers" 
    :useSearch="false">
      <template v-slot:child="{ child }">
        <p class="mb-5">Properties</p>
        <div class="bg-primary-light rounded">
          <div class="p-4 border-0 border-gray border-solid" :class="index !== 0 ? 'border-t' : ''" v-for="(g, index) in child.variableProperties" :key="'var' + index">
            
            <span v-if="g.oldValue != g.newValue">{{g.name}}: <s style="color :red;">{{g.oldValue}}</s> {{g.newValue}} <small>{{g.state}}</small></span>
            <span v-if="g.oldValue == g.newValue">{{g.name}}: {{g.newValue}}</span>

          </div>
        </div>
      </template>
    </expandabel-table>
  </div>

</template>

<script>

import ExpandabelTable from 'components/ExpandabelTable'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    showAll: false,
    componentKey: 0,
    headers: {
      name: 'Label name',
      variableState: 'State'
    },
    columnsToNotSort: [ 'arrow' ]
  }),
  components: {
    ExpandabelTable
  },
  computed: {
    currentVariables() {

      const data = this.data && this.data.length && this.data.length > 0 && this.data[0].variablesDelta;
      if(data === 0)
        return [];
        
      return data.map(d => ({
        ... d,
        expandableData: d,
        id: d.name
      })).filter(v => v.variableState !== 'Unchanged' || this.showAll);
    }
  },
  methods: {
    async getData() {
    }
  },
  async mounted() {
    await this.getData();
    this.componentKey++;
  }
}
</script>


<style scoped>
h3 {
  color:wheat;
}
h3.Removed {
  color: crimson;
}
h3.Added {
  color:white;
}
</style>